import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'redux-first-router-link'
import styles from './SidebarLink.module.scss'
import buttonStyles from 'global_styles/buttons.module.scss'
import classnames from 'classnames'
import Analytics from 'analytics'

const SidebarLink = (props) => {
  const {
    name,
    to,
    customClass
  } = props

  const buttonLikeClasses = classnames(buttonStyles.buttonClean, styles.SidebarLink, customClass)

  const trackableLinks = [
    'Getting Started',
    'Personal Information',
    'Identity Verification',
    'Employment Details',
    'Review & Submit'
  ]
  const trackNavItemClick = () => {
    const sanitizedName = name.replace(/[0-9]+\.\s+/, '')
    if (trackableLinks.includes(sanitizedName)) {
      Analytics.track(`User clicks ${sanitizedName} in Navigation`)
    }
  }

  return (
    <div className={buttonLikeClasses}>
      <NavLink
        activeClassName={styles.active}
        to={to}
        onClick={trackNavItemClick}>
        {name}
      </NavLink>
    </div>
  )
}

SidebarLink.propTypes = {
  name: PropTypes.string.isRequired,
  customClass: PropTypes.string,
  to: PropTypes.object
}

SidebarLink.defaultProps = {
  customClass: '',
  to: {}
}

export default SidebarLink



// WEBPACK FOOTER //
// ./src/components/Onboarding/PWMSidebar/SidebarLink/SidebarLink.jsx